﻿import { Box, Typography } from '@mui/material';
import Diia from '~/components/icons/Diia.tsx';
import Lock from '~/components/icons/Lock.tsx';
import Arrow from '~/components/icons/Arrow.tsx';
import { selectSignatureStyles as styles } from './styles';

interface ISelectSignatureTypeProps {
  handleSignatureDiia?: () => void;
  handleSignatureIIT?: () => void;
  isDiiaSignatureDisabled: boolean;
  isIITSignatureDisabled: boolean;
  diiaDisabledMessage?: string;
}

export const SelectSignatureType = ({
  handleSignatureDiia,
  handleSignatureIIT,
  isDiiaSignatureDisabled,
  isIITSignatureDisabled,
  diiaDisabledMessage,
}: ISelectSignatureTypeProps) => {
  const showDiiaSignature =
    !!handleSignatureDiia && (!isDiiaSignatureDisabled || !!diiaDisabledMessage);
  const showIITSignature = !!handleSignatureIIT && !isIITSignatureDisabled;
  const isDiiaDisabled = isDiiaSignatureDisabled;

  return (
    <>
      <Typography variant="h4" component="h4" sx={styles.title}>
        Електронний підпис
      </Typography>
      <Box sx={styles.cardsContainer} data-testid="select-signature-view">
        {showDiiaSignature && (
          <Box sx={styles.card}>
            <Box
              onClick={!isDiiaDisabled ? handleSignatureDiia : undefined}
              aria-disabled={isDiiaDisabled}
              data-testid="signature-diia-button"
              sx={styles.cardTopState(isDiiaDisabled)}
            >
              <Box sx={styles.cardContent}>
                <Diia />
                <Box sx={styles.cardTextDiia}>
                  <Typography variant="h5" component="h5" sx={styles.cardHeader}>
                    За допомогою
                    <br /> Дія.Підпису
                  </Typography>
                </Box>
              </Box>
              <Arrow />
            </Box>

            {isDiiaDisabled && !!diiaDisabledMessage && (
              <Typography sx={styles.disabledMessage}>{diiaDisabledMessage}</Typography>
            )}
          </Box>
        )}

        {showIITSignature && (
          <Box sx={styles.card}>
            <Box
              onClick={handleSignatureIIT}
              data-testid="signature-iit-button"
              sx={styles.cardTopState(false)}
            >
              <Box sx={styles.cardContent}>
                <Lock />
                <Box sx={styles.cardText}>
                  <Typography variant="h5" component="h5" sx={styles.cardHeader}>
                    За допомогою
                    <br /> електронного підпису (IIT)
                  </Typography>
                </Box>
              </Box>
              <Arrow />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default SelectSignatureType;
